
import { toast } from "react-toastify"
import { fetchConToken } from "../helpers/fetch"

export const Model = {

    getAll: async ({ url }) => {
        try {

            const resp = await fetchConToken(url)
            const body = await resp.json()
            if (body.ok) {
                return body.data || null

            } else {

                toast.error('Lo sentimos, ocurrió un error')
                return null
            }

        } catch (error) {

            toast.error(error)
        }
    },

    getOne: async ({ url }) => {
        try {

            const resp = await fetchConToken(url)
            const body = await resp.json()

            if (body.ok) {
                return body.data || null

            } else {
                toast.error('Lo sentimos, ocurrió un error')
                return null
            }

        } catch (error) {
            toast.error(error)
        }
    },

    save: async (params) => {
        try {

            const { url, dataForm, resultData = false, showMessage = true } = params

            const resp = await fetchConToken(url, dataForm, 'POST')
            const body = await resp.json()

            if (body.ok) {

                if (showMessage) {
                    toast.success(body.msg)
                }

                return resultData ? body.data : body.data.id

            } else {

                toast.error(body.msg)
                return null

            }

        } catch (error) {
            toast.error(error)
        }
    },

    update: async (params) => {
        try {

            const { url, dataForm, showMessage = true } = params

            const resp = await fetchConToken(url, dataForm, 'PUT')
            const body = await resp.json()

            if (body.ok) {

                if (showMessage) {
                    toast.success(body.msg)
                }

                return body.data

            } else {

                toast.error(body.msg)
                return null
            }

        } catch (error) {

            console.log(error)
            toast.error(error)
        }
    },

    delete: async ({ url, dataForm = {}, resultData = false }) => {
        try {

            const resp = await fetchConToken(url, dataForm, 'DELETE')
            const body = await resp.json()

            if (body.ok) {

                toast.success(body.msg)
                return resultData ? body?.data : body.ok

            } else {

                toast.error(body.msg)
                return null
            }

        } catch (error) {

            console.log(error)
            toast.error(error)
        }
    },

    patch: async (params) => {
        try {
            const { url, dataForm = {}, showMessage = true } = params

            const resp = await fetchConToken(url, dataForm, 'PATCH')
            const body = await resp.json()

            if (body.ok) {
                if (showMessage) toast.success(body.msg)
                return body.data
            } else {
                toast.error(body.msg)
                return null
            }

        } catch (error) {
            console.log(error)
            toast.error(error)
        }
    }

}